import { render, staticRenderFns } from "./proceedingOpinion.vue?vue&type=template&id=6842859b"
import script from "./proceedingOpinion.vue?vue&type=script&lang=js"
export * from "./proceedingOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6842859b')) {
      api.createRecord('6842859b', component.options)
    } else {
      api.reload('6842859b', component.options)
    }
    module.hot.accept("./proceedingOpinion.vue?vue&type=template&id=6842859b", function () {
      api.rerender('6842859b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingOpinion.vue"
export default component.exports